import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { PlanPrep } from "../../../domain/contracts/PlanPrep";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read PlanPrep info
 * for a given DOT_PayItem{index} aspect.
 */
function buildPlanPrepByElementQuery(
  index: DOTPayItemIndex,
): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.PlanPrep.LabelPlanP AS LabelPlanP,
      p.PlanPrep.LabelNote  AS LabelNote,
      p.PlanPrep.Label1     AS Label1,
      p.PlanPrep.Label2     AS Label2
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryPlanPrepForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<PlanPrep | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildPlanPrepByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;  // { LabelPlanP, LabelNote, Label1, Label2 }
    return PlanPrep.fromObject(plain);
  }

  // No PlanPrep info for that element/index
  return undefined;
}

